"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ui_components_1 = require("@idp/ui-components");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var utils_1 = require("@idp/ui-components/utils");
var ButtonProps_1 = require("@idp/ui-components/components/atoms/Button/ButtonProps");
var Checkout_cms_1 = require("../../../../cms/Checkout.cms");
var Utils = require("../../../../utils/UtilityFunctions");
var cms_integration_1 = require("@idp/cms-integration");
var styles = require("./PaymentScheduleModal.scss");
var Api_1 = require("../../../../api/Api");
var ReportingService_1 = require("../../../../api/ReportingService");
var LegalAPI_1 = require("../../../../api/LegalAPI");
var CartConfiguration_scss_1 = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var components_1 = require("@idp/duc/components");
var PaymentScheduleModal = /** @class */ (function (_super) {
    __extends(PaymentScheduleModal, _super);
    function PaymentScheduleModal(props) {
        var _this = _super.call(this, props) || this;
        _this.legalLongContent = new Array();
        _this.state = {
            modalLegalContent: {},
            showContentWithoutModal: false,
            showModal: false,
        };
        _this.api = new Api_1.default();
        _this.legalApi = new LegalAPI_1.default();
        _this.initializeEvents();
        _this.modalCMSData = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content.dueTodayPanel.paymentScheduleModalContent;
        _this.commonFieldsCmsData = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content.commonFields;
        _this.printDates = _this.printDates.bind(_this);
        _this.paymentModelMapInfoNew = _this.paymentModelMapInfoNew.bind(_this);
        _this.renderModalMapContent = _this.renderModalMapContent.bind(_this);
        _this.showModalContent = _this.showModalContent.bind(_this);
        _this.paymentModelMapInfo = _this.paymentModelMapInfo.bind(_this);
        _this.showLegalContent = _this.showLegalContent.bind(_this);
        _this.paymentScheduleDescription = _this.paymentScheduleDescription.bind(_this);
        _this.parseMapInfo = _this.parseMapInfo.bind(_this);
        _this.showLegalModalContent = _this.showLegalModalContent.bind(_this);
        _this.reportingService = new ReportingService_1.default();
        return _this;
    }
    PaymentScheduleModal.prototype.componentWillMount = function () {
        if (this.props.options && this.props.options.showContentWithoutModal) {
            this.setState({
                showContentWithoutModal: true,
            });
        }
        if ((this.modalCMSData.legalatttvDisclaimerNew &&
            this.modalCMSData.legalatttvDisclaimerNew.legalModalPath) &&
            (this.modalCMSData.legalDisclaimer &&
                this.modalCMSData.legalDisclaimer.legalModalPath)) {
            this.getLegalContent(this.modalCMSData.legalDisclaimer.legalModalPath[0]);
        }
    };
    PaymentScheduleModal.prototype.render = function () {
        var _this = this;
        var legalMandateLinkStyle = this.props.data.legalMandate ? styles.paymentTvLink : '';
        return (this.state.showContentWithoutModal ?
            (React.createElement(React.Fragment, null,
                this.renderModalMapContent(),
                React.createElement(ui_components_1.Modal, { testId: utils_1.default('Modal', 'DTVN_Payment_Schedule_Legal'), options: {
                        center: true,
                        className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                        isRedesign: true,
                        show: this.state.showModal,
                        showClose: true, size: ModalProps_1.ModalSizes.MEDIUM,
                    }, events: { onClose: function () { _this.onModalClosed('Close'); } } }, this.showLegalModalContent())))
            :
                (React.createElement(React.Fragment, null,
                    React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Link', 'DTVN_Payment_Schedule'), onClick: this.modalLinkEvents.onClick, className: legalMandateLinkStyle }, !this.props.data.legalMandate ?
                        this.modalCMSData.scheduleFuturePayLinkLabel :
                        this.modalCMSData.schedulePayLinkLabel),
                    React.createElement("div", null,
                        React.createElement(ui_components_1.Label, { data: { text: this.modalCMSData.taxesAndFeesLable }, options: { className: styles.excludeTax } })),
                    React.createElement(ui_components_1.Modal, { testId: utils_1.default('Modal', 'DTVN_Payment_Schedule'), options: {
                            center: true,
                            className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                            isRedesign: true,
                            show: this.state.showModal,
                            showClose: true, size: ModalProps_1.ModalSizes.MEDIUM,
                        }, events: { onClose: function () { _this.onModalClosed('Close'); } } }, this.showModalContent()))));
    };
    PaymentScheduleModal.prototype.printDates = function (prepayMap) {
        var prepayMapData = prepayMap;
        var check = Object.entries(prepayMapData).
            map(function (_a, i) {
            var keys = _a[0], values = _a[1];
            return (React.createElement("div", { key: i },
                React.createElement("b", null,
                    "$",
                    [values]),
                " will start on ",
                [keys]));
        });
        return check;
    };
    PaymentScheduleModal.prototype.parseMapInfo = function (prepayMap, mapType) {
        if (prepayMap) {
            var mapInfo = Object.entries(prepayMap).
                map(function (_a, i) {
                var keys = _a[0], values = _a[1];
                return ({ month: keys, amount: values, type: mapType });
            });
            return mapInfo;
        }
        else {
            return null;
        }
    };
    PaymentScheduleModal.prototype.onModalOpen = function () {
        this.setState({ showModal: true });
        var linkName = !this.props.data.legalMandate ? this.modalCMSData.dtvnLinkLabel : 'See Payment Schedule';
        this.reportingService.fireLinkClickWithOutPageLoad(linkName, ReportingService_1.PageUrls.SEE_PAYMENT_SCHEDULE_MODAL_CART);
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.SEE_PAYMENT_SCHEDULE_MODAL_CART);
    };
    PaymentScheduleModal.prototype.onModalClosed = function (btnName) {
        this.setState({ showModal: false });
        this.reportingService.fireLinkClickWithOutPageLoad(btnName, ReportingService_1.PageUrls.SEE_PAYMENT_SCHEDULE_MODAL_CART);
        if (this.props.options && this.props.options.pageLoadUrl) {
            this.reportingService.firePageLoadEvent(this.props.options.pageLoadUrl);
        }
    };
    PaymentScheduleModal.prototype.initializeEvents = function () {
        this.modalLinkEvents = {
            onClick: this.onModalOpen.bind(this),
        };
        this.onModalClosed = this.onModalClosed.bind(this);
    };
    PaymentScheduleModal.prototype.getLegalContent = function (legalAEMUrl) {
        var _this = this;
        if (legalAEMUrl) {
            var legalatttvDisclaimer_1 = this.modalCMSData.legalatttvDisclaimerNew;
            var legalDisclaimer_1 = this.modalCMSData.legalDisclaimer;
            var legalContent_1 = {};
            this.legalApi.getLegal(legalAEMUrl).then(function (response) {
                if (legalAEMUrl === legalatttvDisclaimer_1.legalModalPath[0]) {
                    legalContent_1.shorttext = legalatttvDisclaimer_1.legalShortPath.legalText;
                    legalContent_1.shortdesclinktext = legalatttvDisclaimer_1.legalShortPath.shortLegalLinkLabel;
                }
                else {
                    legalContent_1.shorttext = legalDisclaimer_1.legalShortPath.legalText;
                    legalContent_1.shortdesclinktext = legalDisclaimer_1.legalShortPath.shortLegalLinkLabel;
                }
                if (response.modaltitle) {
                    legalContent_1.modaltitle = response.modaltitle;
                }
                if (response.longtext) {
                    legalContent_1.longtext = response.longtext;
                }
                _this.setState({
                    modalLegalContent: legalContent_1,
                });
            }).catch(function (err) {
                legalContent_1.showLegal = false;
                _this.setState({
                    modalLegalContent: legalContent_1,
                });
            });
        }
    };
    PaymentScheduleModal.prototype.renderModalMapContent = function () {
        return (React.createElement("div", null,
            this.paymentScheduleDescription(),
            this.paymentModelMapInfo(),
            this.showLegalContent()));
    };
    PaymentScheduleModal.prototype.paymentModelMapInfo = function () {
        var legalContent = this.props.data.legalContent;
        return (React.createElement(React.Fragment, null,
            legalContent && legalContent.prePay_Map &&
                React.createElement("div", null, !this.state.showContentWithoutModal &&
                    React.createElement("div", null,
                        React.createElement("h3", null, this.modalCMSData.discountPaymentThreeMonths.replace('[[total_months]]', legalContent.prePay_Map.duration)),
                        React.createElement("p", null,
                            React.createElement("b", null,
                                "$",
                                legalContent.prePay_Map.dueToday),
                            " will start today."))),
            legalContent && legalContent.discounted_Map &&
                React.createElement("div", { className: [styles.marginTop20, styles.marginBottom20].join(' ') },
                    !this.state.showContentWithoutModal &&
                        !(this.props.options && this.props.options.hideDiscountMapHeading) &&
                        React.createElement("h3", null, this.modalCMSData.discountPayments),
                    this.printDates(legalContent.discounted_Map)),
            legalContent && legalContent.regular_Map &&
                React.createElement("div", { className: styles.marginBottom20 },
                    React.createElement("div", { className: styles.regularPayment }, this.modalCMSData.regularPayment),
                    this.printDates(legalContent.regular_Map))));
    };
    PaymentScheduleModal.prototype.showLegalContent = function () {
        if (this.state.modalLegalContent && this.state.modalLegalContent.longtext) {
            return (React.createElement(ui_components_1.Label, { data: { isDecodingRequired: true, text: this.state.modalLegalContent.longtext }, options: { className: styles.descriptionLegal } }));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    PaymentScheduleModal.prototype.paymentModelMapInfoNew = function () {
        var monthlyAutCharges = new Array();
        var legalContent = this.props.data.legalContent;
        if (legalContent && legalContent.discounted_Map) {
            monthlyAutCharges = this.parseMapInfo(legalContent.discounted_Map, 'discounted');
        }
        if (legalContent && legalContent.regular_Map) {
            monthlyAutCharges = monthlyAutCharges.concat(this.parseMapInfo(legalContent.regular_Map, 'regular'));
        }
        return (React.createElement(React.Fragment, null, monthlyAutCharges.length > 0 &&
            React.createElement("table", { className: styles.monthlyAutoCharges },
                React.createElement("caption", { className: styles.tableHeading }, this.modalCMSData.monthlyAutoChargesLabel || 'Monthly auto-charges'),
                React.createElement("tbody", null, monthlyAutCharges.map(function (obj, index) {
                    var oddrow = (index % 2) === 0 ? styles.trOdd : '';
                    return (React.createElement("tr", { key: '_charges' + index, className: oddrow },
                        React.createElement("td", { className: styles.tableColumnMonth }, obj.month),
                        React.createElement("td", { className: styles.tableColumnAmount },
                            React.createElement("div", null,
                                "$",
                                Utils.amountWithDecimal(obj.amount, 2)),
                            obj.type && obj.type === 'regular' &&
                                React.createElement("div", { className: styles.prevailingRate }, "(or the then-prevailing rate)"))));
                })))));
    };
    PaymentScheduleModal.prototype.showModalContent = function () {
        var dtvnModalTitle = this.modalCMSData.dtvnModalTitle;
        return (React.createElement("div", { className: CartConfiguration_scss_1.rennyModalContainer },
            React.createElement("div", { className: styles.modalTitle }, dtvnModalTitle),
            this.paymentScheduleDescription(),
            this.paymentModelMapInfo(),
            this.showLegalContent()));
    };
    PaymentScheduleModal.prototype.showLegalModalContent = function () {
        var _this = this;
        if (this.legalLongContent[1]) {
            return (React.createElement("div", { className: CartConfiguration_scss_1.rennyModalContainer },
                React.createElement("div", { className: styles.modalTitle }, this.state.modalLegalContent.modaltitle),
                React.createElement(ui_components_1.Label, { data: { isDecodingRequired: true, text: this.legalLongContent[1].replace('*', '') }, options: { className: styles.descriptionLegalOncheckout } }),
                React.createElement("div", { className: styles.buttonContainer },
                    React.createElement(ui_components_1.Button, { data: { text: 'Got it' }, events: { onClick: function () { _this.onModalClosed('Got it'); } }, options: { className: styles.buttonContainer, type: ButtonProps_1.ButtonType.PRIMARY }, testId: utils_1.default('DTVN', 'Button', 'GotIt') }))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    PaymentScheduleModal.prototype.paymentScheduleDescription = function () {
        var activateServiceLabel = this.state.modalLegalContent && !!this.state.modalLegalContent.shorttext &&
            this.state.modalLegalContent.shorttext.replace('<p>', '').split('</p>')[0];
        if (activateServiceLabel) {
            activateServiceLabel = activateServiceLabel.replace('[[startDate]]', this.props.data.billingStartDate);
            activateServiceLabel = this.modalCMSData.headingDescription;
            var isIptvMigrationSource = false;
            if (Utils.getMigrationSource() === 'IPMIG') {
                isIptvMigrationSource = true;
                activateServiceLabel =
                    this.modalCMSData.legalShortTextIPTV.replace('[[startDate]]', this.props.data.billingStartDate);
            }
            return (React.createElement("div", { className: styles.marginBottom20 },
                React.createElement("span", { className: [styles.pright5px, styles.descriptionText].join(' ') },
                    React.createElement(ui_components_1.RichText, { data: { text: activateServiceLabel + (this.state.showContentWithoutModal ? '.' : '') }, testId: utils_1.default('Checkout', 'RichText', 'Heading_Desc') })),
                this.state.showContentWithoutModal &&
                    React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Link', 'Payment_Schedule_See_Details'), onClick: this.modalLinkEvents.onClick, className: styles.linkSmall }, this.modalCMSData.atttvLinkLable || 'See additional details'),
                !this.state.showContentWithoutModal && !isIptvMigrationSource &&
                    React.createElement("span", { className: styles.descriptionText },
                        React.createElement(ui_components_1.RichText, { data: { text: this.modalCMSData.atttvModalLable }, testId: utils_1.default('Checkout', 'RichText', 'Desc') }))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    return PaymentScheduleModal;
}(React.Component));
exports.default = PaymentScheduleModal;
//# sourceMappingURL=PaymentScheduleModal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PaymentDetailsPanel/PaymentScheduleModal/PaymentScheduleModal.js
// module id = 2387
// module chunks = 8